import moment from 'moment'

export default (...e) => moment(...e)
